/**
 * Shared sidebar-item-id → tenant module catalog key map.
 *
 * Used by both the desktop `Sidebar.jsx` and the mobile `MobileSidebarDrawer.jsx`
 * so future modules added to the master grant catalog (`backend/tenant_utils.py`
 * MODULE_CATALOG) only need ONE edit on the frontend.
 *
 * Convention:
 *   • Keys are sidebar item ids (kebab-case, matching `PINNED_ITEMS[].id` /
 *     `MORE_ITEMS[].id`).
 *   • Values are the canonical module catalog ids defined on the backend.
 *   • A missing key OR a `null` value means the item is NOT gated by tenant
 *     grants — it always renders (e.g. agency dashboard, free sources).
 */
export const MODULE_MAP = {
  "agency-dashboard": null,           // always visible (home page)
  "prospecting":     "search",
  "kanban":          "kanban",
  "gov-kanban":      "public_works",
  "free-sources":    null,            // free-tier surface, always shown
  "public-works":    "public_works",
  "b2c-intent":      "b2c_intent",
  "b2c-radar":       "b2c_intent",
  "lead-gap":        "lead_gap",      // gated — premium / growth+ only
  "campaigns":       "campaigns",
  "insights":        "insights",
  "roi":             "roi",
  "marketing-apis":  "marketing_apis",
  "replies":         "replies",
  "integrations":    "integrations",
  "webhooks":        "integrations",
  "library":         "library",
  "scrapers":        "scrapers",
  "instagram":       "scrapers",
  "linkedin":        "scrapers",
  "youtube":         "scrapers",
};

/**
 * Decide if a sidebar item should render for the current user.
 *
 *   • Admins (super_admin / admin / master / master_demo) always see everything.
 *   • Non-cliente roles (legacy users without a tenant) see everything.
 *   • Clientes only see items whose module key is in `tenantModuleGrants`.
 *   • Items without a module key (e.g. agency-dashboard) are always visible.
 */
export function isItemGranted(itemId, { isMaster, isCliente, tenantModuleGrants }) {
  if (isMaster) return true;
  if (!isCliente) return true;
  if (!tenantModuleGrants) return true;
  const key = MODULE_MAP[itemId];
  return key == null ? true : tenantModuleGrants.includes(key);
}
